import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Module-level counter so overlapping Portal instances don't re-enable
// body scroll when one unmounts while another is still mounted.
let portalDepth = 0;

// Renders children into document.body, escaping any parent stacking context
// (e.g. backdrop-blur, transform, filter on ancestor elements).
// Also locks body scroll while any Portal-based modal is mounted.
export default function Portal({ children }) {
    const instanceId = useRef(Symbol());

    useEffect(() => {
        portalDepth++;
        if (portalDepth === 1) {
            document.body.classList.add('modal-open');
        }
        return () => {
            portalDepth = Math.max(0, portalDepth - 1);
            if (portalDepth === 0) {
                document.body.classList.remove('modal-open');
            }
        };
    }, []);

    return createPortal(children, document.body);
}
